"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectDevice = void 0;
const constants_1 = require("../constants");
function detectDevice() {
    const userAgent = navigator.userAgent;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const desktopRegex = /Windows|Macintosh|Linux/i;
    const nativeWebviewRegex = /((wv|sdk) \([^\)]+\))|WebView/i;
    if (nativeWebviewRegex.test(userAgent)) {
        return constants_1.Device.WEBVIEW;
    }
    else if (mobileRegex.test(userAgent)) {
        return constants_1.Device.MOBILE;
    }
    else if (desktopRegex.test(userAgent)) {
        return constants_1.Device.DESKTOP;
    }
    else {
        return constants_1.Device.UNKNOWN;
    }
}
exports.detectDevice = detectDevice;
